import SidebarPreview from './classes/SidebarPreview';

// Register Sidebar Preview for DICOM Dump
OC.Plugins.register('OCA.Files.SidebarPreviewManager', new SidebarPreview());
